import { render, staticRenderFns } from "./UserConfig.vue?vue&type=template&id=a6d8b5ba&scoped=true"
import script from "./UserConfig.vue?vue&type=script&lang=js"
export * from "./UserConfig.vue?vue&type=script&lang=js"
import style0 from "./UserConfig.vue?vue&type=style&index=0&id=a6d8b5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d8b5ba",
  null
  
)

export default component.exports